//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/JamTestNamespace.Subspace.js";
import "../JamTestNamespace/JamTestNamespace.Subspace.TransientObj.js";
let d=[[],[[["input"],"SetStructB",{},1,0],[[],"GetStructB",{R_:{input:''}},0,0]],[]];
SPLM.JamTestNamespace.Subspace.TransientObjB = class extends SPLM.JamTestNamespace.Subspace.TransientObj{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.JamTestNamespace.Subspace.TransientObjB";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.JamTestNamespace.Subspace.TransientObjB.Struct2 = class{
    constructor(b,s){
        this.b=b;this.s=s;}
    get B(){return this.b}
    set B(val){this.b = val}
    get S(){return this.s}
    set S(val){this.s = val}
};

export default SPLM;